import { render, staticRenderFns } from "./gatewaysList.vue?vue&type=template&id=506923ca&scoped=true&"
import script from "./gatewaysList.vue?vue&type=script&lang=js&"
export * from "./gatewaysList.vue?vue&type=script&lang=js&"
import style0 from "./gatewaysList.vue?vue&type=style&index=0&id=506923ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506923ca",
  null
  
)

export default component.exports